import * as React from 'react';
import classnames from 'classnames';
import StoreGroupFinderItem from '../StoreFinderItem/StoreFinderItemContainer.js';

const PreferredStoreTile = ({ className , store , loading =false  })=>/*#__PURE__*/ React.createElement(StoreGroupFinderItem, {
        className: classnames('stores-v2-preferred-store-tile', className),
        store: store,
        loading: loading,
        variant: "bordered",
        isPreferredStore: true,
        showAttributesAsTags: true
    })
;
var PreferredStoreTile$1 = PreferredStoreTile;

export { PreferredStoreTile$1 as default };
//# sourceMappingURL=PreferredStoreTile.js.map
